// Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getToken, logoutUser,getValue } from '../utils/auth';

// Base URL for API requests
const baseURL = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  adminSettingsHistory: [],
  status: 'idle',
  error: null,
};

// Async thunk for fetching admin settings history
export const fetchAdminSettingsHistory = createAsyncThunk(
  'admin/fetchAdminSettingsHistory',
  async () => {
    let pageNum = getValue('adminhistory_cur_page')??1;
  let size = getValue('adminhistory_page_size')??10;
    try {
      const response = await axios.get(`${baseURL}/api/adminSetting/getAdminSettingsHistory?page=${pageNum}&pageSize=${size}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 400) {
        logoutUser(); 
      }
      throw error;
    }
  }
);

// Slice for managing admin history state
const adminHistorySlice = createSlice({
  name: 'adminHistory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminSettingsHistory.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAdminSettingsHistory.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.adminSettingsHistory = action.payload;
      })
      .addCase(fetchAdminSettingsHistory.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        if (action.error.code === "ERR_BAD_REQUEST") {
      logoutUser();
        }
      });
  },
});

export default adminHistorySlice.reducer;
